import { useEffect, useState } from "react";
import { V3Loader } from "../Loader"

export const ImportingContentLoader = () => {

    const [stepNo, setStepNo] = useState(0);

    const steps = [
        `Loading your content...`,
        "Just a moment...",
        "Importing your content...",
        "Almost there...",
        "Hang tight, we're working on it...",
        "Preparing your content...",
    ];

    useEffect(() => {
        const myInterval = setInterval(() => {
            setStepNo((stepNo) => {
                if (stepNo === steps.length - 1) return stepNo;
                return stepNo + 1;
            })
        }, 4000);

        return () => {
            clearInterval(myInterval);
        }
    }, []);


    return <V3Loader height={130} loadingText={steps[stepNo]} />
}